<template>
  <div>
    <v-skeleton-loader
      :loading="loading"
      :transition="fade-transition"
      height="94"
      type="list-item-avatar-two-line"
      width="100%"
    >
      <no-results
        v-if="promotions.length === 0"
        title="Actualmente no tienes promociones activas"
        description="Agrega promociones a tu tienda para atraer mas clientes"
      />
      <v-list
        v-else
        two-line
        subheader
      >
        <v-subheader inset>
          Promociones
        </v-subheader>
        <v-list-item
          v-for="item in promotions"
          :key="item.title"
        >
          <v-list-item-avatar>
            <v-icon>mdi-sale</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
            <v-list-item-subtitle> Valor del cupón de descuento: {{ item.value }} </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon>
              <v-icon
                color="green"
                @click="dialog = true"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-skeleton-loader>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="promotions.length === 0"
            block
            color="secondary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Agregar Promoción
          </v-btn>
        </template>
        <v-card>
          <v-tabs
            v-model="tab"
            background-color="primary"
            dark
          >
            <v-tab
              v-for="item in itemsTab"
              :key="item.tab"
            >
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="item in itemsTab"
              :key="item.tab"
            >
              <v-card flat>
                <template v-if="item.value==='discount'">
                  <h1>Descuento</h1>
                  <v-btn @click="dialog = false" />
                </template>
                <template v-if="item.value==='firstTimeCoupon'">
                  <v-card
                    class="mx-auto"
                    outlined
                  >
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="text-h5 mb-1">
                          Cupón de descuento para primeros Usuarios
                        </v-list-item-title>
                        <v-list-item-subtitle>Al activar esta promoción en su tienda los usuarios que hagan la primera compra en su tienda y la persona que lo refirió tendrán un cupón de descuento del valor estipulado.</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-card-actions>
                      <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                      >
                        <v-text-field
                          v-model="value"
                          :rules="nameRules"
                          label="Valor del cupón de descuento"
                          required
                        />
                        <v-btn
                          :disabled="!valid || addingPromotion"
                          :loading="addingPromotion"
                          color="success"
                          class="mr-4"
                          @click="addFirstCodePromotion"
                        >
                          Agregar promoción
                        </v-btn>
                        <v-btn
                          color="error"
                          class="mr-4"
                          @click="dialog = false"
                        >
                          Cancelar
                        </v-btn>
                      </v-form>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>

  export default {
    components: {
      NoResults: () => import('@/components/custom/NoResults.vue'),
    },

    props: {
      shop: Object,
    },

    data: () => ({
      tab: null,
      itemsTab: [
        // { tab: 'Descuentos', value: 'discount' },
        { tab: 'Cupón Primera Compra', value: 'firstTimeCoupon' },
      ],
      dialog: false,
      item: 1,
      nameRules: [
        v => !!v || 'Valor del cupón es requerido',
        v => (v && !isNaN(v)) || 'El valor ingresado no es numerico',
      ],
      valid: true,
      value: 0,
      loading: true,
      addingPromotion: false,
    }),
    computed: {
      promotions () {
        return this.$store.getters['promotions/getPromotions']
      },
    },
    created () {
      this.$store.dispatch('promotions/getPromotions').then(() => {
        this.loading = false
      })
    },
    methods: {
      addFirstCodePromotion () {
        this.addingPromotion = true
        this.loading = true
        this.$store.dispatch('promotions/saveFirstCodePromotion', this.value).then(() => {
          this.$store.dispatch('promotions/getPromotions').then(() => {
            this.loading = false
            this.addingPromotion = false
          })
        }).finally(() => {
          this.dialog = false
        })
      },
    },
  }
</script>

<style scoped>
</style>
